import { useCallback, useEffect, useState } from 'react';
import { hrApi } from '@/api';
import { EmployeeSelect } from '@/components/selects';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { showApiError } from '@/utils/apiError';
import { RecordDataTable } from '@/components/ui/RecordDataTable';
import { notify } from '@/core/toast/notify';

export function HrSuccessionPage() {
  const [plans, setPlans] = useState<unknown[]>([]);
  const [positionName, setPositionName] = useState('');
  const [incumbentId, setIncumbentId] = useState('');

  const load = useCallback(async () => {
    try {
      setPlans(await hrApi.listSuccessionPlans());
    } catch (err) {
      showApiError(err, 'Failed to load succession plans');
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const create = async () => {
    try {
      await hrApi.createSuccessionPlan({ positionName, incumbentId: incumbentId ? Number(incumbentId) : undefined, riskLevel: 'HIGH' });
      notify.success('Plan created');
      load();
    } catch (err) {
      showApiError(err, 'Create failed');
    }
  };

  return (
    <div>
      <PageHeader title="Succession planning" description="Critical positions, successors, and risk analysis" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Succession' }]} />
      <section className="card mb-4 space-y-3 p-4">
        <Input label="Critical position" value={positionName} onChange={(e) => setPositionName(e.target.value)} />
        <EmployeeSelect label="Incumbent employee" value={incumbentId} onChange={setIncumbentId} />
        <Button onClick={() => void create()}>Create plan</Button>
      </section>
      <RecordDataTable data={plans} emptyTitle="No succession plans yet" />
    </div>
  );
}
